import PropTypes from 'prop-types';
import {isNil} from 'ramda';
import React, {Component} from 'react';
import {withRouter} from 'react-router';
import styled from 'styled-components';
import {Grid, Progress, Statistic} from 'semantic-ui-react';
import {retrieveBalances} from '../../api';
import MenuButton from '../../components/Button/MenuButton';
import {backgroundColorFromTotal, BRIGHT_RED, BlueContainer, DARK_GREEN, YELLOW, BLUE, DARK_GREEN_ALPHA_15, YELLOW_ALPHA_15, BRIGHT_RED_ALPHA_15, DARK_GREEN_ALPHA_30, BRIGHT_RED_ALPHA_30} from '../../components/Container/ContainerMix';
import {currencyFormatter, formatDate} from '../../util/Utils';
import Spinner from '../../components/Spinner/Spinner';

const Title = styled.h5`
  color: rgba(255, 255, 255, 1);
  min-width: 150px;
  font-family: Roboto;
  cursor: pointer;
  padding: 9px 0;
`;


const ProgressHeader = styled(BlueContainer)`
  min-height: 224px;
  color: #FFFFFF;
  justify-content: start;
  text-align: center;
  flex-direction: column;
  padding: 0 10px 10px 10px;
  & > h3 {
    font-size: 18px;
  }
  background-size: calc(130vw) calc(110vw),calc(110vw) calc(130vw),auto;
  display: flex;
  padding: 0 10px 15px 10px;
  & ${Title} {
    font-size: 24px;
    color: #ffffff;
  }
`;

const Wrapper = styled.div`
  height: calc(100vh - 86px);
  position: unset;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;


const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FlexWithPadding = styled(Flex)`
  padding: 0px 10px;
  height: 86px;
  justify-content: flex-start;
  background-color: ${BLUE}
`;


const Logo = styled.img`
  max-width: 35px;
  max-height: 35px;
  padding: 0 5px 0 0;
`;

const MenuText = styled.span`
  display: flex;
  flex: 1;
  justify-content: center;
  margin-right: 46px;
`;

const HeaderStatisticWrapping = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const BottomStatisticWrapping = styled(HeaderStatisticWrapping)`
  margin-top: 30px;
`;

const HeaderStatistic = styled.div`
  flex: 1;
  color: rgba(255,255,255,.75);
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  & span {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 10px;
  }
`;

const BottomStatistic = styled.div`
  flex: 1;
  color: #000000;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  & span {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 10px;
  }
`;

const BottomColoredStatisticValue = styled.span`
  color: ${props => props.color} !important;
`;


const StyledGridColumn = styled(Grid.Column)`
  text-align: center !important;
  background-color: ${props => props['data-color']} !important;
  padding: 0 !important;
  display: flex !important;
  flex-direction: row  !important;
  align-content: center !important;
  align-items: center !important;
  justify-content: center !important;
`;

const StyledProgress = styled(Progress)`
  &.ui.progress {
    right: 0 !important;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 10px;
    margin: 10px 20px;
    & .bar {
      border-radius: 10px;
    }
    & .label {
      color: #ffffff !important;
      margin-top: 10px;
    }
  }
`;

const TableWrapper = styled.div`
  padding: 21px;
  background-color: #f6f6f6
  position: relative;
  padding-bottom: 100px;
  & h3 {
    margin-bottom: 20px;
  }
  height: calc(100vh - 224px);
}
`;

const ColoredStatisticValue = styled(Statistic.Value)`
  color: ${props => props.color} !important;
  padding: 10px 0;
`;

const StyledGrid = styled(Grid)`
  margin: 0;
  & .row {
    padding: 0 !important;
  }
`;

const HeaderStatisticLabel = styled(Statistic.Label)`
  &.label {
    color: rgba(0,0,0,0.87) !important;
    padding: 5px 5px 5px 0!important;
    font-weight: normal !important;
    font-size: 8px !important;
    line-height: 10px;
    text-align: left !important;
  }
`;

const StatisticCell = styled(Statistic)``;

class SemesterProgress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      balances: null
    };
  }

  componentDidMount() {
    this.setState({isLoading: true});

    return retrieveBalances()
      .then(response => {
        this.setState({isLoading: false, balances: response.data});
      });
  }

  onTitleClick = () => {
    const {router} = this.props;
    router.push('/dashboard');
  };
  
  render() {
    const {isLoading, balances} = this.state;
    const {onClickSidebar} = this.props;
    return (
      isLoading || isNil(balances) ?
        <Spinner text="Loading..."/> :
      (
        <div>
          <FlexWithPadding>
            <MenuButton onClick={onClickSidebar}/>
            <MenuText>
              <Logo src="images/mark-white.svg" alt="Logo" />
              <Title onClick={this.onTitleClick}>My BodyBank Account</Title>
            </MenuText>
          </FlexWithPadding> 
          <Wrapper>
            <ProgressHeader>
              <Title>Overall</Title>
              <StyledProgress value={balances.semester_user_points + balances.semester_streak_points} total={balances.semester.points_needed} progress="ratio" autoSuccess indicating color="blue">
                {formatDate(balances.semester.start_date)} - {formatDate(balances.semester.end_date)}
              </StyledProgress>
              <HeaderStatisticWrapping>
                <HeaderStatistic><span>{balances.semester.points_needed - (balances.semester_user_points + balances.semester_streak_points)}</span>Points remaining</HeaderStatistic>
                <HeaderStatistic><span>{Math.round((new Date(balances.semester.end_date) - new Date()) / (1000 * 60 * 60 * 24))}</span>Days remaining</HeaderStatistic>
              </HeaderStatisticWrapping>
            </ProgressHeader>
            <TableWrapper>
              <h3>Previous Week</h3>
              <StyledGrid columns={4}>
                <StyledGridColumn/>
                <StyledGridColumn>
                  <Statistic>
                    <HeaderStatisticLabel>Green days</HeaderStatisticLabel>
                  </Statistic>
                </StyledGridColumn>
                <StyledGridColumn>
                  <Statistic>
                    <HeaderStatisticLabel>Yellow days</HeaderStatisticLabel>
                  </Statistic>
                </StyledGridColumn>
                <StyledGridColumn>
                  <Statistic>
                    <HeaderStatisticLabel>Red days</HeaderStatisticLabel>
                  </Statistic>
                </StyledGridColumn>
              </StyledGrid>
              <StyledGrid columns={8}>
                <StyledGridColumn width={4}>
                  <Statistic>
                    <HeaderStatisticLabel>Balances:</HeaderStatisticLabel>
                  </Statistic>
                </StyledGridColumn>
                <StyledGridColumn data-color={DARK_GREEN_ALPHA_30}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={DARK_GREEN}>{balances.daily_balance_color_count.dark_green}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
                <StyledGridColumn data-color={DARK_GREEN_ALPHA_15}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={DARK_GREEN}>{balances.daily_balance_color_count.light_green}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
                <StyledGridColumn data-color={YELLOW_ALPHA_15} width={4}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={YELLOW}>{balances.daily_balance_color_count.yellow}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
                <StyledGridColumn data-color={BRIGHT_RED_ALPHA_15}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={BRIGHT_RED}>{balances.daily_balance_color_count.light_red}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
                <StyledGridColumn data-color={BRIGHT_RED_ALPHA_30}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={BRIGHT_RED}>{balances.daily_balance_color_count.dark_red}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
              </StyledGrid>
              <StyledGrid columns={8}>
                <StyledGridColumn width={4}>
                  <Statistic>
                    <HeaderStatisticLabel>Food Levels:</HeaderStatisticLabel>
                  </Statistic>
                </StyledGridColumn>
                <StyledGridColumn data-color={DARK_GREEN_ALPHA_30}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={DARK_GREEN}>{balances.daily_food_color_count.dark_green}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
                <StyledGridColumn data-color={DARK_GREEN_ALPHA_15}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={DARK_GREEN}>{balances.daily_food_color_count.light_green}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
                <StyledGridColumn data-color={YELLOW_ALPHA_15} width={4}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={YELLOW}>{balances.daily_food_color_count.yellow}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
                <StyledGridColumn data-color={BRIGHT_RED_ALPHA_15}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={BRIGHT_RED}>{balances.daily_food_color_count.light_red}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
                <StyledGridColumn data-color={BRIGHT_RED_ALPHA_30}>
                  <StatisticCell size="tiny">
                    <ColoredStatisticValue color={BRIGHT_RED}>{balances.daily_food_color_count.dark_red}</ColoredStatisticValue>
                  </StatisticCell>
                </StyledGridColumn>
              </StyledGrid>
              <BottomStatisticWrapping>
                <BottomStatistic><span>{balances.days_banked}</span>Days banked</BottomStatistic>
                <BottomStatistic>
                  <BottomColoredStatisticValue color={backgroundColorFromTotal(balances.weekly_balance, true)}>{currencyFormatter.format(balances.weekly_balance)}</BottomColoredStatisticValue>
                  Weekly balance
                </BottomStatistic>
              </BottomStatisticWrapping>
            </TableWrapper>
          </Wrapper>           
        </div>
        )
    );
  }
}

SemesterProgress.propTypes = {
  onClickSidebar: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(SemesterProgress);



// WEBPACK FOOTER //
// ./src/pages/Balances/SemesterProgress.js